
export function calculatePercentage(fragment?: number, total?: number) {
    return fragment && total ? Math.round((fragment / total) * 100) : 0;
}
